import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Report, RowActions } from '../../../report/report';
import { FetchBussinesService } from '../../../report/services/fetch-bussines.service';

@Component({
  selector: 'app-crm',
  templateUrl: './crm.component.html',
  styleUrls: ['./crm.component.scss']
})
export class CrmComponent implements OnInit {

  tableColumns: string[] = [
    'name',
    'code',
    'pendingToAvailable',
    'date'
  ];

  displayTableColumns = {
    'name': 'Business Name',
    'code': 'Code',
    'pendingToAvailable' : 'Pending Days',
    'date': 'Created At'
  };

  totalNumberOfRecords = 0;
  crmReportData: any[] = [];
  requestBody: Report = {};
  loading = false;

  rowActions: RowActions[] = [{
    actionName: 'View',
    actionType: 'Button',
    actionClass: 'btn-primary',
  }];

  constructor(
    public fetchBussiness: FetchBussinesService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.fetchBussiness.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  actionsCB(object: any) {
    console.log(object);
    if (object.action === 'View') {
      this.view(object.key.id);
    }
  }


  async filter($event: any) {
    if ($event && Object.keys($event).length) {
      this.requestBody.filterOptions = $event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.fetchBussiness.loader().subscribe(val => (this.loading = val));
  }

  async paginate($event: any) {
    this.requestBody.paginationOptions = {
      start: $event.pageIndex * $event.pageSize,
      limit: $event.pageSize
    };
    this.updateTable();
    this.fetchBussiness.loader().subscribe(val => (this.loading = val));
  }

  async searchChange($event: any) {
    if ($event) {
      this.requestBody.searchOptions = {
        searchKey: $event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.fetchBussiness.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.fetchBussiness.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.fetchBussiness.activateLoader();
    this.fetchBussiness.setParams(this.requestBody);
    const report = await this.fetchBussiness.make();
    this.crmReportData = report.result.map(obj => ({
      ...obj,
      pendingToAvailable: obj.pendingToAvailable === 0 ? "0" : obj.pendingToAvailable.toString()
  }));
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  view(id: any) {
    this.router.navigateByUrl(`/admin/actions/crm/profile/${id}`);
  }
}
